import { useSelector } from 'react-redux';
import { getVariantStock } from 'domains/Catalog/Products/productsSlice/productSelectors';

function useVariantsStock() {
  return useSelector(getVariantStock);
}

export default useVariantsStock;
